import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconCopy = memo(({ color = 'black', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M19 21H8V7h11m0-2H8a2 2 0 00-2 2v14a2 2 0 002 2h11a2 2 0 002-2V7a2 2 0 00-2-2m-3-4H4a2 2 0 00-2 2v14h2V3h12V1z"
      />
    </Svg>
  );
});
